module.exports = __webpack_public_path__ + "static/media/available.87bdef47.jpeg";